/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from '../../assets/images/svg/info-circle.svg';

const TooltipWrapper = styled.span`
  position: relative;
  display: inline-block;
  margin-left: 6px;
  cursor: pointer;
  margin-top: 2px;

  &:hover .tooltip-box {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

const TooltipBox = styled.div`
  position: absolute;
  top: 24px;
  left: -55px;
  background: #f8f9fa;
  color: #a2a5b5;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.4;
  width: 250px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 0.2s ease-in-out;
  z-index: 10;
  display: flex;
  align-items: flex-start;
  gap: 8px;

  svg {
    flex-shrink: 0;
    color: #051d37;
    margin-top: 2px;
  }
`;

const CustomRefinementList = ({ items, refine, isClosedList }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: isClosedList ? 'none' : 'block' }}>
      <ul
        className="ais-RefinementList-list"
        style={{ marginBottom: 'calc(2rem * var(--legacy-scale, 1))' }}
      >
        {items.map((item) => (
          <li key={item.label} className="ais-RefinementList-item">
            <label className="ais-RefinementList-label">
              <input
                className="ais-RefinementList-checkbox"
                type="checkbox"
                checked={item.isRefined}
                onChange={() => refine(item.value)}
              />
              <span className="ais-RefinementList-labelText">
                {item.label === 'Fractional Holdings'
                  ? 'InstaVault'
                  : item.label}
              </span>
              <span className="ais-RefinementList-count"> {item.count}</span>

              {item.label === 'Fractional Holdings' && (
                <TooltipWrapper>
                  <InfoIcon size={10} style={{ marginBottom: '-2px' }} />
                  <TooltipBox className="tooltip-box">
                    <InfoIcon size={14} style={{ marginTop: '2px' }} />
                    <span>{t('common.instaVaultLocation')}</span>
                  </TooltipBox>
                </TooltipWrapper>
              )}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

CustomRefinementList.propTypes = {
  items: PropTypes.arrayOf({}),
  refine: PropTypes.func,
  isClosedList: PropTypes.bool,
};

export const RefinementListWithTooltip = connectRefinementList(
  CustomRefinementList,
);
